import { render, staticRenderFns } from "./LisansDurumuView.vue?vue&type=template&id=1be875d8&scoped=true"
import script from "./LisansDurumuView.vue?vue&type=script&lang=ts"
export * from "./LisansDurumuView.vue?vue&type=script&lang=ts"
import style0 from "./LisansDurumuView.vue?vue&type=style&index=0&id=1be875d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be875d8",
  null
  
)

export default component.exports